import React, { FC, ReactElement, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Roles } from '../../commonType';
import ErrorMessage from '../../components/common/ErrorMessage';
import withLocalization from '../../components/hoc/withLocalization';
import withRoles from '../../components/hoc/withRoles';
import BillingInformationForm from '../../components/OfferContactInformation/BillingInformationForm_FA';
import CheckBoxController from '../../components/OfferContactInformation/CheckBoxController';
import ContactInformationForm from '../../components/OfferContactInformation/ContactInformationForm';
import ContactInformationHeader from '../../components/OfferContactInformation/ContactInformationHeader';
import ContactInformationSelector from '../../components/OfferContactInformation/ContactInformationSelector';
import CybeSourceFlexForm from '../../components/OfferContactInformation/CyberSource';
import { getSupportedCards } from '../../components/OfferContactInformation/CyberSource/paymentUtil';
import TermsAndConditionSelector from '../../components/OfferContactInformation/TermsAndConditionSelector';
import { NavigationSteps } from '../../components/OfferDetails/OfferNavigation';
import PackageSummary from '../../components/OfferEligibility/PackageSummary';
import { RootState } from '../../redux/rootReducer';
import {
  resetConfirmationError,
  resetConfirmationNumber,
  retrievePaymentContext,
  setflexFormSubmitHandler,
  // eslint-disable-next-line prettier/prettier
  setPaymentButtonState,
} from '../offerConfirmation/offerConfirmationSlice';
import { setNavigationStep } from '../offerSearch/offerSearchSlice';
import { loadScriptInHead } from '../../util/index';

const OfferContactInformationContainer: FC<any> = (props: any): ReactElement => {
  const { localize } = props;
  const dispatch = useDispatch();
  const paymentContextId = useSelector((state: RootState) => state.confirmation.paymentContextId);
  const hasError = useSelector((state: RootState) => state.confirmation.hasPaymentContextError);
  const errorObject = useSelector((state: RootState) => state.confirmation.error);
  const error = hasError ? <ErrorMessage errorObject={errorObject}></ErrorMessage> : <></>;
  const conversationMode = useSelector((state: RootState) => state.offerDetails.conversationMode);
  const showCVV = conversationMode === 'person' ? true : false;
  const cardStyle = {
    input: {
      'font-size': '16px',
      color: '#5f5f5f',
    },
    ':focus': { color: 'blue' },
    ':disabled': { cursor: 'not-allowed' },
    valid: { color: '#000' },
    invalid: { color: '#a94442' },
  };

  useEffect(() => {
    console.log('paymentContextId', paymentContextId);
  }, [paymentContextId]);

  useEffect(() => {
    // Associate PBE- JScrambler
    const scriptUrl = process.env.REACT_APP_JSCRAMBLER_SCRIPT_URL;
    let scriptElement;

    if (scriptUrl) {
      loadScriptInHead(scriptUrl)
        .then((script) => {
          console.log('JSCRAMBLER Script added');
          scriptElement = script;
        })
        .catch(() => console.error('Failed to add the JSCRAMBLER script'));
    }
    return () => {
      if (scriptElement) {
        document.head.removeChild(scriptElement);
      }
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(resetConfirmationNumber());
    dispatch(setNavigationStep(NavigationSteps.OFFER_CONTACT_INFO));
    dispatch(resetConfirmationError());
  }, [dispatch]);
  useEffect(() => {
    if (props.userRole === Roles.Field_Associate) {
      if ((!paymentContextId || paymentContextId.length === 0) && !hasError) {
        dispatch(
          retrievePaymentContext(
            process.env.REACT_APP_MERCHANT_GROUPID ? process.env.REACT_APP_MERCHANT_GROUPID : '',
            window.location.origin,
          ),
        );
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentContextId]);
  useEffect(() => {
    // console.log('Page loaded');
    // // values read from capture context
    // const clientLibrary = props.clientLibraryJwt;
    // const clientLibraryIntegrity = props.clientLibraryIntegrityJwt;
    // // create script tag
    // const script = document.createElement('script');
    // script.src = clientLibrary;
    // script.type = 'text/javascript';
    // script.async = true;
    // script.integrity = clientLibraryIntegrity;
    // script.crossOrigin = 'anonymous';
    // // run setup code after script has loaded successfully
    // script.onload = function () {
    //   // SETUP
    // };
    // // insert to document
    // document.head.appendChild(script);
    // // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <div className="container">
        <ContactInformationHeader />
        {error}
        <div className="row">
          <div className="col-sm-8">
            {props.userRole === Roles.Call_Center_Associate ? (
              <>
                <ContactInformationForm />
                <ContactInformationSelector />
              </>
            ) : (
              <>
                <ContactInformationForm />
                <CheckBoxController />
                <BillingInformationForm />
                {paymentContextId && paymentContextId.length > 0 ? (
                  <CybeSourceFlexForm
                    context={paymentContextId ? paymentContextId : ''}
                    style={cardStyle}
                    cardPlaceHolder={''}
                    mvwcMerchantGroupAcceptableCard={getSupportedCards()}
                    showCVV={showCVV}
                    cvvPlaceHolder={''}
                    emptyCreditCardMessage={localize(
                      'preview-sales-engine.static-content.copy.Labels.labels#credit-card-number-error-message',
                    )}
                    invalidCreditCardMessage={localize(
                      'preview-sales-engine.static-content.copy.Labels.labels#credit-card-invalid',
                    )}
                    invalidCvvMessage={localize(
                      'preview-sales-engine.static-content.copy.Labels.labels#cvv-error-message',
                    )}
                    invalidMonthYearMessage={localize(
                      'preview-sales-engine.static-content.copy.Labels.labels#month-year-combo-error-message',
                    )}
                    isFormValid={(isValid) => {
                      dispatch(setPaymentButtonState(isValid));
                    }}
                    formObjectCallback={(obj) => {
                      dispatch(setflexFormSubmitHandler(obj));
                    }}
                  ></CybeSourceFlexForm>
                ) : (
                  <></>
                )}
                <TermsAndConditionSelector />
                <ContactInformationSelector />
              </>
            )}
          </div>
          <div className="col-sm-4">
            <PackageSummary />
          </div>
        </div>
      </div>
    </>
  );
};
export default React.memo(withLocalization(withRoles(OfferContactInformationContainer)));
